import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import GridList, {processPagingParams} from '../fw/GridList.react';
import ScenarioGrid from '../scenarios/ScenarioGrid.react';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import {defaultPageSize} from '../fw/PagingGrid.react';
import * as Tool from '../fw/Tool';
import DetailBox from '../fw/DetailBox.react.js';

import {sortRules} from '../../common/model-api/ScenarioChannelDefRuleType';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import ScreenDisplayer, {ScreenDisplayerListener} from '../view/box-utils/ScreenDisplayer.react';
import {getViewDefinitionFragment, getDataSourceDefinitionFragment} from '../view/box-utils/ScreenFragments.react';
import FakePanel from '../scenarios/FakePanel.react';
import {variableResolver} from '../../common/util/VariableResolver';
import { User } from '../../common/types/types';

interface ScenarioDefDetailProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ScenarioDefDetail extends React.Component<ScenarioDefDetailProps> {

    typeName = 'scenarioDefs';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }


    renderScreenDef(screenDefs) {
        return screenDefs.map(({node: data}) => {
            if (data.hideInScenario) {
                return null;
            }

            let views = data.views;
            let dataSources = data.dataSources;

            return (
                <div key={data.realId}>
                    <FakePanel>
                        <ScreenDisplayer
                            content={data.content}
                            isPreview
                            listener={new ScreenDisplayerListener()}
                            relay={this.props.relay}
                            viewsWithData={Object.keys(views).map((viewId) => {
                                            let view = views[viewId];
                                            let dataSource;

                                            if (view['dataSource_id']) {
                                                dataSource = dataSources.find((dataSource) => dataSource['realId'] === view['dataSource_id']);
                                            }

                                            let result = ({
                                                view: view,
                                                data: '[]',
                                                entityDef: dataSource ? dataSource['primaryEntityDef'] : null,
                                                addon: '{}',
                                            });

                                            return result;
                                        })}
                        />
                    </FakePanel>
                </div>
            );
        });

    }

	// eslint-disable-next-line max-params
    myGetFormatted(type, field, data, variables) {
        let value = Tool.getDataForColumn(field, type.fields(), data);

        if (value) {
            return Tool.tranformDataForView(type.entity(), type.fields(field), this.props.intl.formatMessage, variableResolver(value, variables), false, 0);
        }
    }

    render() {
        const scenarioDef = this.props.user.scenarioDefs.edges[0].node;
        let type = types[this.typeName];

        let ruleTypes = {};
        let variables = {};

        for (let rule of scenarioDef.channelDefRules.edges.map(({node}) => node).sort(sortRules)) {
            let key = rule.key;

            if (!key) {
                key = rule.ruleType;
            }

            if (!ruleTypes[key]) {
                ruleTypes[key] = rule;
            }

            if (rule.include !== 'exclude') {
                if (rule.name) {
                    variables[key] = rule.name;
                } else if (!variables[key]) {
                    variables[key] = key;
                }
            }
        }

        let title = variableResolver(Tool.getDataForColumn('title', type.fields(), scenarioDef), variables);
        if (!title) {
            title = variableResolver(Tool.getDataForColumn('name', type.fields(), scenarioDef), variables);
        }

        let description = this.myGetFormatted(type, 'description', scenarioDef, variables);
        let longDescription = this.myGetFormatted(type, 'longDescription', scenarioDef, variables);

        let requiredPayPlan = scenarioDef.requiredPayPlan;

        if (requiredPayPlan) {
            if (requiredPayPlan === "-") {
                requiredPayPlan = null;
            } else {
                requiredPayPlan = Tool.getFormatted(type, 'requiredPayPlan', this.props.intl.formatMessage, scenarioDef);
            }
        }

        return (
            <AppPanel breadcrumbParams={[
                {type, scenarioDef},
                {type: types['scenarioDefs'], data: this.props.user.scenarioDef}
            ]} title={scenarioDef.name}>
                <div className="scenarioView"
                     data-description={description}
                     data-title={title}
                >
                    <DetailBox data={scenarioDef} metadata={type} urlMapping={urlMapping}>
                        <div className="header">
                            {/*<ScenarioIcon scenario={scenarioDef} />*/}

                            <div className="text">
                                <span className="flex"></span>
                                <h2>{title}</h2>
                                <p>{description}</p>

                                {requiredPayPlan ?
                                    <div className="scenario-note">
                                    <span>
                                        <FormattedMessage defaultMessage="Requires {planName}."
                                                          id="scenario.payPlan.requires"
                                                          values={{planName: requiredPayPlan}}/>
                                        <br/>
                                    </span>
                                    </div> : null
                                }
                                <span className="flex"></span>
                            </div>
                        </div>
                    </DetailBox>

                    {longDescription}

                    <h3><FormattedMessage defaultMessage="Connected Applications and Services" id="scenario.connectedApps.title" /></h3>
                    {this.renderScreenDef(scenarioDef.screenDefs.edges)}

                    <h2><FormattedMessage defaultMessage="Supported apps" id="scenarioDef.channelDefs.listApps" /></h2>
                    {Object.keys(ruleTypes).map((ruleTypeKey, idx) => {
                        let ruleType = ruleTypes[ruleTypeKey];

                        let channelDefs = scenarioDef.scenarioDefs2ChannelDefs.edges.map(({node}) => node).filter((rule) => {
                            let ruleKey = ruleType['key'];
                            if (!ruleKey) {
                                ruleKey = ruleType['ruleType'];
                            }

                            if (rule['key'] !== ruleKey) {
                                return false;
                            }

                            if (!rule.channelDef || rule.channelDef.visibility !== 'public') {
                                return false;
                            }

                            if (rule.channelDef.state !== 'beta' && rule.channelDef.state !== 'published') {
                                return false;
                            }

                            return true;
                        }).map((rule) => rule.channelDef);

                        if (channelDefs.length <= 1) {
                            return null;
                        }

                        return (
                            <div key={idx}>
                                <h3>{ruleType.name ? ruleType.name : ruleType.key}</h3>
                                <GridList
                                    edges={{edges: channelDefs.map((channelDef) => {return ({"node": channelDef}); })}}
                                    getUrl={(item) => {
                                        return urlMapping.getUrl('channelDefs', 'public-apps', item);
                                    }}
                                    iconProperty="icon"
                                    metadata={types['channelDefs']}
                                    relay={this.props.relay}
                                    tagsProperty="state"
                                    titleProperty="name"
                                    urlMapping={urlMapping}
                                />
                            </div>
                        );
                    })}

					{ scenarioDef.relevantScenarios.edges.length > 0 ?
						<div>
							<h2><FormattedMessage defaultMessage="Scenarios" id="scenarioDefDetail.scenarios.list" /></h2>
							<ScenarioGrid
								edges={scenarioDef.relevantScenarios}
								metadata={types['scenarios']}
								pageInfo={scenarioDef.relevantScenarios.pageInfo}
								relay={this.props.relay}
								urlMapping={urlMapping}
							/></div>
						: null
					}


                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ScenarioDefDetail), (props) => {
    return props.user.scenarioDefs.edges && props.user.scenarioDefs.edges.length > 0;
}), {
    initialVariables: {
        scenarioDefUrlFragment: '',
        first: defaultPageSize,
        after: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenarioDefs: publicScenarioDefs(first: 1, urlFragmentRaw: $scenarioDefUrlFragment) {
                    edges {
                        node {
                            id,
                            name,
                            title,
                            description,
                            longDescription,
                            requiredPayPlan,
                            state,
                            visibility,
                            urlFragment,
                            realId,
                            screenDefs(first: 10) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        name,
                                        description,
                                        entityDef_id,
                                        entityDef {
                                            id,
                                            name,
                                        },
                                        scenarioDef_id,
                                        content,
                                        operation,
                                        hideInScenario,
                                        views {
                                            ${getViewDefinitionFragment()}
                                        },
                                        dataSources {
                                            ${getDataSourceDefinitionFragment()}
                                        }
                                    }
                                }
                            },
                            relevantScenarios(first: 20) {
                                edges {
                                    node {
                                        id,
                                        ${ScenarioBox.getFragment('scenario')}
                                    }
                                },
		                        pageInfo {
		                            hasNextPage,
		                            hasPreviousPage,
		                            startCursor,
		                            endCursor
		                        }
                            },
                            scenarioDefs2ChannelDefs(first: 2000) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        key,
                                        channelDef {
                                            id,
                                            realId,
                                            visibility,
                                            urlFragment,
                                            state,
                                            name,
                                            icon,
                                            state
                                        },
                                    }
                                }
                            },
                            channelDefRules(first: 2000) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        key,
                                        ruleType,
                                        include,
                                        name
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
